import { action } from 'typesafe-actions'
import { Province } from '@models/province'
import {RequestData} from "@models/axios";

export const enum ProvincesActionTypes {
    FETCH_REQUEST = '@@provinces/FETCH_REQUEST',
    FETCH_SUCCESS = '@@provinces/FETCH_SUCCESS',
    FETCH_ERROR = '@@provinces/FETCH_ERROR',

    DELETE_REQUEST = '@@provinces/DELETE_REQUEST',
    DELETE_SUCCESS = '@@provinces/DELETE_SUCCESS',
    DELETE_ERROR = '@@provinces/DELETE_ERROR',

    CREATE_REQUEST = '@@provinces/CREATE_REQUEST',
    CREATE_SUCCESS = '@@provinces/CREATE_SUCCESS',
    CREATE_ERROR = '@@provinces/CREATE_ERROR',

    UPDATE_REQUEST = '@@provinces/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@provinces/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@provinces/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@provinces/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@provinces/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@provinces/FETCH_ITEM_ERROR",
}



export const fetchRequest = (data:RequestData) => action(ProvincesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Province[]) => action(ProvincesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(ProvincesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(ProvincesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(ProvincesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(ProvincesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(ProvincesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Province[]) => action(ProvincesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(ProvincesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(ProvincesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Province[]) => action(ProvincesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(ProvincesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(ProvincesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Province[]) => action(ProvincesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(ProvincesActionTypes.FETCH_ITEM_ERROR, message);